<template>
  <transition name="blur">
    <div class="distribute-roles-popup" v-if="show" @click.self="cancel">
      <div class="popup-content">
        <h4>{{ $t("session.distributeRoles") }}</h4>
        <p class="message">{{ $t("session.confirmDistributeRoles") }}</p>
        
        <div class="checkbox-section">
          <label class="checkbox-label">
            <input type="checkbox" v-model="sendBluffsToLunatic" />
            <span>{{ $t("session.alsoSendBluffsToDemon") }}</span>
          </label>
        </div>
        
        <div class="button-group">
          <button @click="confirm" class="btn-confirm">
            <font-awesome-icon icon="check" />
            {{ $t("common.confirm") }}
          </button>
          <button @click="cancel" class="btn-cancel">
            <font-awesome-icon icon="times" />
            {{ $t("common.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initialCheckboxValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sendBluffsToLunatic: false,
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.sendBluffsToLunatic = this.initialCheckboxValue;
      }
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm', this.sendBluffsToLunatic);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.distribute-roles-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 60px 20px 20px 20px;
  
  .popup-content {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.85) 100%);
    border-radius: 10px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);
    padding: 0;
    min-width: 280px;
    max-width: 350px;
    
    h4 {
      margin: 0;
      padding: 15px 20px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
      color: white;
    }
    
    .message {
      padding: 15px 20px;
      margin: 0;
      color: rgba(255, 255, 255, 0.9);
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
    }
    
    .checkbox-section {
      padding: 12px 20px;
      background: rgba(255, 255, 255, 0.05);
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      
      .checkbox-label {
        display: flex;
        align-items: center;
        cursor: pointer;
        gap: 10px;
        color: white;
        font-size: 13px;
        
        input[type="checkbox"] {
          width: 18px;
          height: 18px;
          cursor: pointer;
          flex-shrink: 0;
        }
        
        span {
          line-height: 1.4;
        }
      }
    }
    
    .button-group {
      display: flex;
      gap: 10px;
      padding: 15px;
      
      button {
        flex: 1;
        padding: 10px 16px;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        white-space: nowrap;
        
        svg {
          width: 14px;
          flex-shrink: 0;
        }
        
        &.btn-confirm {
          background: linear-gradient(135deg, #00a550 0%, #008040 100%);
          color: white;
          box-shadow: 0 2px 8px rgba(0, 165, 80, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #00c060 0%, #00a550 100%);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 165, 80, 0.5);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
        
        &.btn-cancel {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
          color: rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(255, 255, 255, 0.2);
          
          &:hover {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%);
            color: white;
            border-color: rgba(255, 255, 255, 0.3);
          }
        }
      }
    }
  }
}

.blur-enter-active,
.blur-leave-active {
  transition: opacity 0.2s;
  .popup-content {
    transition: transform 0.2s, opacity 0.2s;
  }
}

.blur-enter,
.blur-leave-to {
  opacity: 0;
  .popup-content {
    transform: translateY(-20px);
    opacity: 0;
  }
}
</style>
